var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionChatbot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-824.000000, -1840.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Chatbot",
    transform: "translate(824.000000, 1839.999700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.125,22.0003 C22.096,22.0003 26.125,26.0293 26.125,31.0003 L26.125,31.0003 L26.125,32.0003 L6.125,32.0003 L6.125,31.0003 C6.125,26.0293 10.154,22.0003 15.125,22.0003 L15.125,22.0003 Z M28,4.8753 L28,15.8753 C28,18.0843 26.209,19.8753 24,19.8753 L24,19.8753 L4,19.8753 L4,8.8753 C4,6.6663 5.791,4.8753 8,4.8753 L8,4.8753 L28,4.8753 Z M14.018,12.8753 L12.88,12.8753 C12.88,14.5983 14.277,15.9953 16,15.9953 C17.723,15.9953 19.12,14.5983 19.12,12.8753 L19.12,12.8753 L17.982,12.8753 C17.982,13.9703 17.095,14.8573 16,14.8573 C14.905,14.8573 14.018,13.9703 14.018,12.8753 L14.018,12.8753 Z M3,8.8753 L3,15.8753 L2,15.8753 C0.896,15.8753 0,14.9793 0,13.8753 L0,13.8753 L0,10.8753 C0,9.7713 0.896,8.8753 2,8.8753 L2,8.8753 L3,8.8753 Z M30,8.8753 C31.104,8.8753 32,9.7713 32,10.8753 L32,10.8753 L32,13.8753 C32,14.9793 31.104,15.8753 30,15.8753 L30,15.8753 L29,15.8753 L29,8.8753 Z M10,9.8753 C9.448,9.8753 9,10.3233 9,10.8753 C9,11.4273 9.448,11.8753 10,11.8753 C10.552,11.8753 11,11.4273 11,10.8753 C11,10.3233 10.552,9.8753 10,9.8753 Z M22,9.8753 C21.448,9.8753 21,10.3233 21,10.8753 C21,11.4273 21.448,11.8753 22,11.8753 C22.553,11.8753 23,11.4273 23,10.8753 C23,10.3233 22.553,9.8753 22,9.8753 Z M17.983,-1.99840144e-15 C17.938,0.683 17.561,1.272 17,1.598 L17,1.598 L17,3.875 L15,3.875 L15,1.598 C14.439,1.272 14.061,0.683 14.017,-1.99840144e-15 L14.017,-1.99840144e-15 Z",
    id: 291
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionChatbot);
export default __webpack_public_path__ + "static/media/navigation-and-action-chatbot.04692279.svg";
export { ForwardRef as ReactComponent };